// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Убираем скроллинг для RouteMapPage (контейнера) */
.route-map-page {
   display: flex;
    flex-direction: column;
    align-items: center;
    height: 120vh;
    width: 100vw;
    overflow: hidden;
}

.leaflet-container {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

.route-map-page.loading {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2em;
    min-height: 100vh;
}

.route-map-page.error {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 1.2em;
    min-height: 100vh;
}

.route-map-page.error button {
    margin-top: 10px;
    padding: 10px 15px;
    background-color: #ff6666;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 5px;
}

.route-map-page.error button:hover {
    background-color: #ff4d4d;
}

/* Стили для MapComponent */
.leaflet-container {
  height: 100%;
  width: 100%;
  z-index: 50;
}


/* Стили для попапов */
.leaflet-popup-content {
    font-size: 1em;
}

.leaflet-popup-content h2 {
  margin-bottom: 10px;
    font-size: 1.2em;
}

.leaflet-popup-content p {
    margin: 5px 0;
}





`, "",{"version":3,"sources":["webpack://./src/modules/Courier/Map/RouteMap.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;GACG,aAAa;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;EACV;;AAEF;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,YAAY;EACZ,WAAW;EACX,WAAW;AACb;;;AAGA,sBAAsB;AACtB;IACI,cAAc;AAClB;;AAEA;EACE,mBAAmB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB","sourcesContent":["/* Убираем скроллинг для RouteMapPage (контейнера) */\r\n.route-map-page {\r\n   display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    height: 120vh;\r\n    width: 100vw;\r\n    overflow: hidden;\r\n}\r\n\r\n.leaflet-container {\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n  }\r\n\r\n.route-map-page.loading {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 1.2em;\r\n    min-height: 100vh;\r\n}\r\n\r\n.route-map-page.error {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 1.2em;\r\n    min-height: 100vh;\r\n}\r\n\r\n.route-map-page.error button {\r\n    margin-top: 10px;\r\n    padding: 10px 15px;\r\n    background-color: #ff6666;\r\n    color: white;\r\n    border: none;\r\n    cursor: pointer;\r\n    border-radius: 5px;\r\n}\r\n\r\n.route-map-page.error button:hover {\r\n    background-color: #ff4d4d;\r\n}\r\n\r\n/* Стили для MapComponent */\r\n.leaflet-container {\r\n  height: 100%;\r\n  width: 100%;\r\n  z-index: 50;\r\n}\r\n\r\n\r\n/* Стили для попапов */\r\n.leaflet-popup-content {\r\n    font-size: 1em;\r\n}\r\n\r\n.leaflet-popup-content h2 {\r\n  margin-bottom: 10px;\r\n    font-size: 1.2em;\r\n}\r\n\r\n.leaflet-popup-content p {\r\n    margin: 5px 0;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
